"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Calendar } from "lucide-react";
function BlogPostsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-96 rounded-xl bg-muted/30 animate-pulse" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">Unable to load blog posts. Please try again later.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="text-center py-12">
        <p className="text-muted-foreground">No blog posts available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
      {posts.map((post, i) => <article key={post.id} data-index={i}>
          <Card className="group overflow-hidden transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-medium">
            {post.featuredImage && <div className="relative h-64 w-full overflow-hidden">
                <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              </div>}
            <CardHeader>
              {post.date && <div className="flex items-center gap-2 text-xs text-accent font-medium">
                  <SafeHydrate><Calendar className="h-3.5 w-3.5" /></SafeHydrate>
                  <time dateTime={post.date}>
                    {new Date(post.date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                  </time>
                </div>}
              <CardTitle className="text-xl font-bold text-primary line-clamp-2">
                {post.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              {post.excerpt && <CardDescription className="line-clamp-3 mb-4">
                  <div dangerouslySetInnerHTML={{
              __html: post.excerpt
            }} />
                </CardDescription>}
              {post.link && <Link to={post.link} className="inline-flex items-center text-sm font-medium text-foreground hover:text-accent transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-0 after:h-px after:w-0 after:bg-accent after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                  Read More →
                </Link>}
            </CardContent>
          </Card>
        </article>)}
    </div>;
}
export default function BlogListing() {
  return <section id="blog-listing" className="dark bg-background text-foreground py-20 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="text-4xl font-bold text-foreground mb-4 font-display">
            Market Insights & Industry News
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Stay informed with our latest analysis, trends, and expert perspectives on global commodity markets.
          </p>
        </div>
        <PostsProvider wp_query={{
        per_page: 6,
        order: "desc",
        orderby: "date"
      }} embeds={["wp:featuredmedia"]} fields={["id", "title.rendered", "excerpt.rendered", "link", "date", "_embedded", "_links.wp:featuredmedia"]}>
          <BlogPostsConsumer />
        </PostsProvider>
      </div>
    </section>;
}